/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const house_value = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.867 10.5v2.002c0 .509.425.934.933.934h8.4a.942.942 0 0 0 .933-.934V10.5M1 8.613l6.34-6.34a.933.933 0 0 1 1.32 0l2.607 2.607M15 8.613l-1.867-1.866M11.267 4.88v-2.4h1.866v4.267M11.267 4.88l1.866 1.867"
    />
    <path
      fill="#000"
      d="M7.775 7.5h-.92L5.771 8.944V7.5H5v3.597h.77v-1.095l.16-.2.874 1.295h.97L6.388 9.232 7.775 7.5Zm2.331 3.597H11l-.766-1.46c.458-.143.715-.503.715-1.032 0-.7-.453-1.105-1.228-1.105H8.287v3.597h.77V9.71h.386l.663 1.387Zm-1.048-2.98h.54c.39 0 .57.154.57.488 0 .334-.18.488-.57.488h-.54v-.976Z"
    />
  </svg>
)
export default house_value
